<script lang="ts">
  import { createEventDispatcher } from 'svelte'
  import AnnouncementCard from '@/components/appDriver/newsfeed/components/AnnouncementCard.svelte'
  import { isNewsPostRead } from '@/components/appDriver/newsfeed/store'
  import type { NewsPost } from '@/components/appDriver/newsfeed/types'

  const dispatch = createEventDispatcher<{ open: { post: NewsPost } }>()

  export let posts: NewsPost[] = []
  export let readPostIds: string[] = []
</script>

<div class="space-y-3">
  {#each posts as post (post.id)}
    <AnnouncementCard
      {post}
      isRead={isNewsPostRead(post.id, readPostIds)}
      on:open={(event) => dispatch('open', event.detail)}
    />
  {/each}
</div>
